module.exports = __webpack_public_path__ + "assets/img/homepage.884320ef.jpg";